module.exports = __webpack_public_path__ + "media/land-for-sale-splash.ef4a72ab.svg";